import { LANGUAGE } from '../../constants/language';
import { getTranslation, type TFnResources } from '../main';
import common_cs from './common.cs';
import common_de from './common.de';
import common_en from './common.en';
import common_sk from './common.sk';

const resources = {
	[LANGUAGE.CZECH]: common_cs,
	[LANGUAGE.SLOVAK]: common_sk,
	[LANGUAGE.ENGLISH]: common_en,
	[LANGUAGE.GERMAN]: common_de,
	/** FIXME: add other translations */
	[LANGUAGE.FRENCH]: {} as any,
	[LANGUAGE.SPANISH]: {} as any,
	[LANGUAGE.RUSSIAN]: {} as any,
	[LANGUAGE.NORWEGIAN]: {} as any,
	[LANGUAGE.SWEDISH]: {} as any,
} as const satisfies TFnResources<any>;

/**
 * Function to get a translation from common resources based on language
 * @param language - The language to use
 * @param path - Dot notation path to the translation
 */
export const getTranslationCommon = (translationLanguage: LANGUAGE) => getTranslation(translationLanguage, resources);
